const Signin = () => {
  return ( 
    <div>
      Signin
    </div>
   );
}
 
export default Signin;